const FEATURE_HELP_URLS = {
  agent_bots: 'https://chat.voxtell.com/hc/agent-bots',
  agents: 'https://chat.voxtell.com/hc/agents',
  audit_logs: 'https://chat.voxtell.com/hc/audit-logs',
  campaigns: 'https://chat.voxtell.com/hc/campaigns',
  canned_responses: 'https://chat.voxtell.com/hc/canned',
  channel_email: 'https://chat.voxtell.com/hc/email',
  channel_facebook: 'https://chat.voxtell.com/hc/fb',
  custom_attributes: 'https://chat.voxtell.com/hc/custom-attributes',
  dashboard_apps: 'https://chat.voxtell.com/hc/dashboard-apps',
  help_center: 'https://chat.voxtell.com/hc/help-center',
  inboxes: 'https://chat.voxtell.com/hc/inboxes',
  integrations: 'https://chat.voxtell.com/hc/integrations',
  labels: 'https://chat.voxtell.com/hc/labels',
  macros: 'https://chat.voxtell.com/hc/macros',
  reports: 'https://chat.voxtell.com/hc/reports',
  sla: 'https://chat.voxtell.com/hc/sla',
  team_management: 'https://chat.voxtell.com/hc/teams',
  webhook: 'https://chat.voxtell.com/hc/webhooks',
  billing: 'https://chat.voxtell.com/pricing',
  saml: 'https://chat.voxtell.com/hc/saml',
  captain_billing: 'https://chat.voxtell.com/hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
